module.exports = __webpack_public_path__ + "img/sh.f3b515b6.svg";